export default {
  format: 'format',
  required: 'required',
};
